import { render, staticRenderFns } from "./item-index-body.vue?vue&type=template&id=248ff190&"
import script from "./item-index-body.vue?vue&type=script&lang=js&"
export * from "./item-index-body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports